import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { cx } from "../utils/cx";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";

// Shell for every signed-in page: navbar on top, sidebar on the left, the page in the Outlet
export default function DashboardLayout() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  // The mobile drawer closes on navigation and on Escape
  useEffect(() => setMenuOpen(false), [pathname]);
  useEffect(() => {
    if (!menuOpen) return undefined;
    const onKey = (e) => e.key === "Escape" && setMenuOpen(false);
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [menuOpen]);

  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar onMenuClick={() => setMenuOpen(true)} />
      <div className="flex">
        {menuOpen && <div className="fixed inset-0 z-40 bg-black/50 md:hidden" onClick={() => setMenuOpen(false)} />}
        <aside
          className={cx(
            "fixed left-0 top-0 z-50 h-full w-72 border-r border-slate-100 bg-white transition-transform duration-300 ease-in-out",
            "md:sticky md:top-16 md:z-auto md:h-[calc(100vh-4rem)] md:w-64 md:translate-x-0 lg:w-72",
            menuOpen ? "translate-x-0" : "-translate-x-full"
          )}
        >
          <Sidebar className="h-full" />
        </aside>
        <main className="min-w-0 flex-1">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
